import { useParams } from "react-router-dom";
import { models } from "../json";
import CarCard from "../components/Card";
import Header from "../components/navbar/Header";
import Footer from "../components/footer/Footer";
import CustomSlider from "../components/CustomSlider";
import nexaBanner from "../assets/banners-3/Banners-Nexa.jpg";
import commercialBanner from "../assets/mobile-banners/home_banners_Commercial_channel_banner.webp";
import truevalueBanner from "../assets/banners-2/Web-Banners-True-value.webp";
import suzukiBanner from "../assets/mobile-banners/home_banners_Suzuki_Channel_banner.webp"
import serviceBanner from "../assets/mobile-banners/Gem_Web_Banners_Arena.webp";
import nexaMobile from "../assets/mobile-banners/Gem_Web_Banners_Nexa.webp";
import commercialMobile from "../assets/mobile-banners/Gem_Web_Banners_Commercial.webp";
import truevalueMobile from "../assets/mobile-banners/Gem_Web_Banners_TV_Buy.webp";
import suzukiMobile from '../assets/mobile-banners/Gem_Web_Banners_Suzuki.webp'
export const channelData = {
  arena: {
    desktop: require('../assets/mobile-banners/home_banners_arena_channel_banner.webp'),
    mobileSlides: [
      { img: serviceBanner, alt: "Arena Offer 1" },
    ],
  },
  nexa: {
    desktop: nexaBanner,
    mobileSlides: [
      { img: nexaMobile, alt: "Nexa Offer 1" },
    ],
  },
  commercial: {
    desktop: commercialBanner,
    mobileSlides: [
      { img: commercialMobile, alt: "Commercial Offer 1" },
    ],
  },
  truevalue: {
    desktop: truevalueBanner,
    mobileSlides: [
      { img: truevalueMobile, alt: "TrueValue Offer 1" },
    ],
  },
  suzuki:{
     desktop: suzukiBanner,
    mobileSlides: [
      { img: suzukiMobile, alt: "TrueValue Offer 1" },
    ],
  }
};


const Channel = () => {
  const { id } = useParams();
  const currentChannel = channelData[id] || channelData["arena"];
  return (
    <>
      <Header />

      <div className="hidden mb-20 md:block">
        <img
          src={currentChannel.desktop}
          className="w-full 
              h-[250px]
              sm:h-[320px]
              md:h-[550px]
              lg:h-[550px]
              xl:h-[550px]
              object-cover  object-center"
          alt={id}
        />
      </div>
      {/* Mobile Slider */}
      <CustomSlider
        slides={currentChannel.mobileSlides}
        effect="fade"
        className="sm:hidden"
        imgClass="lg:mt-16"
      />
      <div className="max-w-screen-xl px-5 mx-auto my-20">
        <p className="my-10 font-semibold text-center capitalize lg:text-3xl">
          {id} Cars
        </p>
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {models.map(
            (item, index) =>
              item.category === id && (
                <CarCard
                  key={index}
                  id={item?.id}
                  tag={item?.tag}
                  banner={item?.pic}
                  title={item?.name}
                  price={item?.price}
                  fuel={item?.fuel}
                  transmission={item?.transmission}
                  engine={item?.cc}
                />
              )
          )}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Channel;
